<ng-container *adaptLoading="!person1 || !person2">
    <h2>{{person1!.fullName}} &amp; {{person2!.fullName}}</h2>
    <p>There is currently no catchup between them.</p>
    <p><small>Catchup due: {{culturalActivity ? (culturalActivity!.date | adaptDate) : "NOW"}}</small></p>
    <button *ngIf="canEditPersonalCatchups && bothPeopleActive"
            adaptButtonIcon="add"
            (click)="recordNewCatchup()"
            class="btn btn-primary btn-pill">New catch-up</button>
    <button *ngIf="canEditPersonalCatchups && bothPeopleActive && isInvolvedPerson"
            adaptButtonIcon="fal fa-calendar-lines-pen"
            (click)="scheduleCatchup()"
            class="btn btn-primary btn-pill">{{isScheduled ? "Reschedule" : "Schedule"}} catch-up</button>
</ng-container>
